import HourlySlotsContainer from "../../container/admin/mail-sender";

const HourlySlotsView = () => {
    return <HourlySlotsContainer />;
};

export default HourlySlotsView;
